<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="idAccion==1"
                    class="mx-auto"
                    color="blue"
                    dark
                    rounded
                    v-bind="attrs"
                    :loading="loading"
                    v-on="on"
                >
                    <v-icon left>
                        mdi-file-plus
                    </v-icon>
                    Agregar Archivo y/o Anexo
                </v-btn>
                <v-btn
                    v-if="idAccion==2"
                    rounded
                    small
                    v-bind="attrs"
                    :loading="loading"
                    v-on="on"
                >
                    <v-icon
                        left
                        small
                    >
                        mdi-square-edit-outline
                    </v-icon>
                    Editar
                </v-btn>

                <v-list-item
                    v-if="idAccion==3"
                    v-bind="attrs"                    
                    v-on="on"
                >
                    <v-list-item-icon class="mr-2">
                        <v-icon>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Consultar</v-list-item-title>
                </v-list-item>
            </template>
            <v-card class="text-center pb-2">
                <v-card-title>
                    <span class="text-h6">                    
                        <v-icon>{{ idAccion == 1 ? 'mdi-file-plus' : idAccion == 2 ? 'mdi-square-edit-outline' : idAccion == 3 ? 'mdi-eye' : '' }}</v-icon>
                        {{ idAccion == 1 ? 'Agregar Archivo y/o Anexo' : idAccion == 2 ? 'Editar Archivo y/o Anexo' : idAccion == 3 ? 'Consultar Archivo y/o Anexo' : '' }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-form 
                        ref="form" 
                        v-model="valid" 
                        :lazy-validation="lazy"
                    >
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12"
                                >
                                    <v-avatar
                                        class="profile" 
                                        color="#F8F8F8"
                                        size="100px"
                                        tile
                                        style="border: 3px solid #27a7d1; border-radius: 10px!important;"
                                    >
                                        <v-icon
                                            color="#D0D0D0"
                                            dark
                                            size="60"
                                        >
                                            mdi-paperclip
                                        </v-icon>
                                    </v-avatar>
                                    <!--        <h3
                                        class="mt-3"
                                        style="color: rgba(0, 0, 0, 0.6);"
                                    >
                                        Archivo y/o Anexo
                                    </h3> -->
                                </v-col>
                            


                                <v-col
                                    cols="12"
                                >
                                    <card-archivo-anexo
                                        :key="'anexo_' + idx + '_file_' + keyRender"
                                        :edit="idAccion == 1 || idAccion == 2"
                                        etiqueta="Archivo y/o Anexo"
                                        :file-anexo="file"
                                        :ban-reset="banResetAnexo"
                                        :file-id="id > 0 ? id : 0"
                                        :file-uuid="uuid"
                                        :file-name="filename"
                                        :fn-change="fnChangeAnexo"
                                    />
                                </v-col>


                                <v-col
                                    cols="12"
                                    class="my-0"
                                >
                                    <v-textarea
                                        v-model="descripcion"
                                        label="Descripción *"
                                        auto-grow
                                        rows="1"
                                        :rules="[(v) => !!v || 'Campo obligatorio']"
                                        :readonly="!(idAccion == 1 || idAccion == 2)"
                                        required
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        depressed
                        rounded
                        @click="dialog = false"
                    >
                        {{ idAccion == 3 ? 'Cerrar' : 'Cancelar' }}
                    </v-btn>
                    <v-btn
                        v-if="idAccion != 3"
                        depressed
                        color="#0e345b"
                        rounded                     
                        :disabled="!validForm"
                        :dark="validForm"
                        :loading="loading"
                        @click="guardarAnexo"
                    >
                        Guardar
                    </v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
        

       

        <v-snackbar
            key="snackbarDialogFormAnexo"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false;"
            >
                Cerrar
            </v-btn>
        </v-snackbar> 
    </div>
</template>

<script>

export default {
  name: "DialogFormAnexo",
  components: {
      CardArchivoAnexo: () => import("../shared/CardArchivoAnexo"),
  },
  props: {
    idAccion: {
      type: Number,
      required: true
    },
    obj: {
        type: Object,
        default: () => {}
    },
    idx: {
        type: Number,
        default: -1
    },
    fnSetValue: {
        type: Function,
        default: () => 1
    },
    fnForceRender: {
        type: Function,
        default: () => 1
    },
  },
  data () {
    return {
        id: -1,
        descripcion: '',
        url: '',
        file: null,
        uuid: '',
        filename: '',
        
        banResetAnexo: 0,

        objSave: {},

        keyRender: 0,

      dialog: false,
      loading: false,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',      

      valid: false,
      lazy: false,

      showTooltip: false
    };
  },
  computed: { 
    validForm: function () {
    return this.valid && (((this.file != null && this.file != undefined) || (this.filename != '' && this.filename != null)) || (this.url != '' && this.url != null && this.url != undefined))
    }  
  },
  watch: {
    dialog: {
      handler (newValue, oldValue) {
          this.setValues(newValue);
      }
    }
  },
  async mounted () {
  },
  methods: {
      setValues (val) {
          if(val == true) {
              if(this.idAccion == 2 || this.idAccion == 3) {
                this.id = this.obj.id;
                this.descripcion = this.obj.descripcion == undefined ? '' : this.obj.descripcion;
                this.file = this.obj.file;
                this.filename = this.obj.filename;
                this.keyRender++;
              }
          }
          else {
            this.id = 0;
            this.descripcion = '';
            this.file = null;
            this.filename = '';
            this.objSave = {};

            this.fnForceRender();
          }

          if(this.$refs.form != undefined) {
            this.$refs.form.resetValidation()
          }
      },
      fnChangeAnexo (file) {
          this.file = file;   
          if(file == null) {
            this.filename = '';
        }      
      },
      guardarAnexo () {

          this.objSave = {
              id: this.id,
              descripcion: this.descripcion,
              file: this.file, 
              filename: this.file == null ? "" : this.file.name
          };

          this.fnSetValue(this.objSave);
          this.dialog=false;
      },
      copyText () {
        this.showTooltip = true;
        navigator.clipboard.writeText(this.url);
            setTimeout(() => {
            this.showTooltip = false;
            }, 3000);
        }
    }
};
</script>

<style scoped>

  .flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>